const VENDOR_ADDON_CODES = new Set([
  "fulfillment-hub",
  "orders-hub",
  "inventory-hub",
  "sales-hub",
]);

const BOTH_ADDON_CODES = new Set([
  "data-tools",
  "data-analytics",
  "reporting-hub",
]);

export function addonAudienceFromCode(code = "") {
  code = String(code).toLowerCase();
  if (VENDOR_ADDON_CODES.has(code)) return "vendor";
  if (BOTH_ADDON_CODES.has(code)) return "both";
  return null; // unknown → don't gate
}

export function audienceFromRates(plan) {
  const list = Array.isArray(plan?.rates_by_user) ? plan.rates_by_user : [];
  if (!list.length) return null; // no signal → don't gate

  const types = new Set(list.map((r) => String(r.type || "").toLowerCase()));
  const hasRetail = types.has("retail") || types.has("retailer");
  const hasVendorish =
    types.has("manufacturer") || types.has("cultivator") || types.has("vendor");

  if (hasRetail && hasVendorish) return "both";
  if (hasRetail) return "retailer";
  if (hasVendorish) return "vendor";
  return null;
}

export function audienceForPlan(plan) {
  const t = plan?.type_code || plan?.type?.code;
  if (t === "add-on") {
    const code = plan?.hub_code || plan?.hub_addons?.[0]?.code || "";
    return addonAudienceFromCode(code);
  }
  if (t === "membership") {
    return audienceFromRates(plan);
  }
  return null;
}

export function visibleForRole(audience, role) {
  if (!audience) return true; // no audience → show
  role = String(role || "").toLowerCase();
  if (!role || role === "unknown" || role === "mixed") return true;

  const vendorish = new Set([
    "vendor",
    "manufacturer",
    "cultivator",
    "processor",
    "wholesaler",
  ]);
  if (role === "retail" || role === "retailer")
    return audience === "retailer" || audience === "both";
  if (vendorish.has(role)) return audience === "vendor" || audience === "both";
  return true;
}

export function resolveCurrentRoleFromState(state) {
  // Step 1: user selection (step 1 of wizard)
  let role = (state.userType || "").toLowerCase();
  if (role) return role;
  // Step 2: derived from licenses (set in hydratePricing)
  role = (state.companyType || "").toLowerCase();
  return role || "unknown";
}
